export const skillsData = [
    {
        label: "FRONT END",
        data: [
            {
                skillsName: "HTML",
                percentage: "80",
            },
            {
                skillsName: "CSS",
                percentage: "70",
            },
            {
                skillsName: "JAVASCRIPT",
                percentage: "50",
            },
        ], 
    },
    {
        label: "BACK END",
        data: [
            {
                skillsName: "REACT.JS",
                percentage: "40",
            },
            {
                skillsName: "NODE.JS",
                percentage: "50",
            },
            {
                skillsName: "EXPRESS",
                percentage: "50",
            },
        ], 
    },
    {
        label: "DATABASE",
        data: [
            {
                skillsName: "MONGODB",
                percentage: "50",
            },
            {
                skillsName: "MYSQL",
                percentage: "50",
            },
        ],  
    }
];
